import React, { useState } from "react";
import MainLayout from "../../Layout/mainLayout";
import "../DealsAndOffers/dealsAndOffers.css";
import ListResaleProperties from "../Properties Resale/listResaleProperties";
import ListInterestedPropertyResale from "../Properties Resale/listInterestedPropertyResale";
import "./headerResaleProperty.css";
import { Skeleton } from "antd";

const STORAGE_KEY = "agent_header_tab";

const HeaderResaleProperty = () => {
  const [selectedTable, setSelectedTable] = useState(
    localStorage.getItem(STORAGE_KEY) || "resale_properties_list"
  );
  const [loading, setLoading] = useState(false);


  const handleTableSelection = (table) => {
    if (table === selectedTable || loading) return;

    setLoading(true);
    setSelectedTable(table);
    localStorage.setItem(STORAGE_KEY, table);

    setTimeout(() => {
      setLoading(false);
    }, 400);
  };

  return (
    <MainLayout>
      <div className="dealsAndOffers-container">
        <div className={`bg-white border-10 padding-10 shadow-box ${loading ? "disabled-tabs" : ""}`}
          style={{ boxShadow: "rgba(0, 0, 0, 0.35) 0px 5px 15px", marginBottom: "20px" }}>
          <div className="hover_panel">
            <h4
              className={selectedTable === "resale_properties_list" ? "clicked" : ""}
              onClick={() => handleTableSelection("resale_properties_list")}
            >
              Property Resale 
            </h4>

            <h4
              className={selectedTable === "resale_properties_interested_list" ? "clicked" : ""}
              onClick={() => handleTableSelection("resale_properties_interested_list")}
            >
              Interested Resale Property
            </h4>
          </div>
        </div>

        {loading && (
          <div className="tab-loader">
            <Skeleton active paragraph={{ rows: 6 }} />
          </div>
        )}

        <div className={`fade-wrapper ${loading ? "hide" : ""}`}>
          <div style={{ display: selectedTable === "resale_properties_list" ? "block" : "none" }}>
            <ListResaleProperties />
          </div>

          <div style={{ display: selectedTable === "resale_properties_interested_list" ? "block" : "none" }}>
            <ListInterestedPropertyResale />
          </div>
        </div>
      </div>
    </MainLayout>
  );
};

export default HeaderResaleProperty;
